<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div class="_idGenPageitem-3">
<img alt="home numbers: family and friendship" class="_idGenPageitem-1" src="image/part1.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// spousecalls4.vue?49d4ba13